// @flow

import type { DataForecastsState } from "./types";

export const initialState: DataForecastsState = {
  error: null,
  requestsInProgress: 0,
  data: {
    highRiskSummary: [],
    employeeRiskRating: [],
    top10Departments: [],
    riskTimeline: [],
  },
};

export default initialState;
